<template>
    <div class="wrapper-bg">
        <div class="main-layout coffee-nofooter">
            <header class="header-page">
                <a class="btn-back" @click="backHistory">
                    <img src="@/assets/icon-back.svg" />
                </a>
                <span class="lbl-header">สิทธิประโยชน์</span>
            </header>
            <div class="banner-main">
                <div class="banner-header">
                    <img
                        v-if="getUserlevel.userlevel === 'gold'"
                        src="@/assets/profile/white_gold_banner.svg"
                        alt=""
                    />
                    <img
                        v-else-if="getUserlevel.userlevel === 'silver'"
                        src="@/assets/profile/white_silver_banner.svg"
                        alt=""
                    />
                    <img
                        v-else
                        src="@/assets/profile/white_bronze_banner.svg"
                        alt=""
                    />
                </div>
                <div class="banner-body">
                    <div class="banner-point">
                        คุณสะสมแล้ว
                        <span :class="getUserlevel.userlevel">{{
                            getUserlevel.point
                        }}</span>
                        แก้ว
                    </div>
                    <div class="progressbar-container">
                        <div class="pointmark-container mb-2">
                            <div class="point">
                                {{
                                    getUserlevel.isMaintain
                                        ? 0
                                        : getUserlevel.currentTierRange.from ||
                                          0
                                }}
                            </div>
                            <div class="point" v-if="getUserlevel.isMaintain">
                                {{ getUserlevel.userLevelMaintain }}
                            </div>
                            <div class="point">
                                {{ getUserlevel.currentTierRange.to || 0 }}
                            </div>
                        </div>
                        <div class="progressbar">
                            <div
                                class="line-image zindex1"
                                :style="{ left: progressBarCalculate(5) + '%' }"
                            >
                                <img
                                    :class="getUserlevel.userlevel"
                                    :src="line_image"
                                    alt=""
                                />
                            </div>
                            <div class="inactive"></div>
                            <div
                                class="active"
                                :class="getUserlevel.userlevel"
                                :style="{ width: progressBarCalculate() + '%' }"
                            ></div>
                        </div>
                        <div class="pointmark-container">
                            <div
                                class="silver"
                                v-if="
                                    getUserlevel.userlevel === 'gold' ||
                                    getUserlevel.userlevel === 'silver'
                                "
                            >
                                SILVER
                            </div>
                            <div class="bronze" v-else>BRONZE</div>
                            <div
                                class="gold"
                                v-if="
                                    getUserlevel.userlevel === 'gold' ||
                                    getUserlevel.userlevel === 'silver'
                                "
                            >
                                GOLD
                            </div>
                            <div class="silver" v-else>SILVER</div>
                        </div>
                    </div>
                    <div class="collect-point">
                        {{ getUserlevel.title }}
                    </div>
                    <div class="tier-date">{{ getUserlevel.date }}</div>
                    <div class="tier-desc">{{ getUserlevel.desc }}</div>
                </div>
            </div>
            <div class="detail-main">
                <div class="tab-main">
                    <div
                        class="tab-container"
                        v-for="(item, index) in Object.keys(dataDetail)"
                        :class="{ active: activeTab === item.toLowerCase() }"
                        :key="index"
                        @click="clickTab(item)"
                    >
                        {{ item.charAt(0).toUpperCase() + item.slice(1) }}
                    </div>
                </div>
                <div class="line"></div>
                <div class="congrat-container">{{ dataSet.congrat }}</div>
                <div class="level-container">{{ dataSet.level }}</div>
                <div
                    class="benefit-container"
                    v-for="(item, index) in dataSet.benefitList"
                    :key="'b_' + index"
                >
                    <img :src="item.image" alt="" />
                    <div class="text-container">
                        <div class="header">{{ item.header }}</div>
                        <div class="desc">{{ item.desc }}</div>
                    </div>
                </div>
                <div class="level-container">{{ dataSet.conditionTitle }}</div>
                <div
                    class="benefit-container"
                    v-for="(item, index) in dataSet.conditonList"
                    :key="'c_' + index"
                >
                    <div class="text-container">
                        <div class="desc">{{ item.header }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
//core
import BzbsCustom from "@/core/Custom/service/BzbsCustom.js";
//helper
import CacheHelper from "@/helper/CacheHelper.js";
//vuex
import { mapGetters } from "vuex";
//mixin
import Mixin from "@/mixin/Mixin";

export default {
    name: "Benefit",
    data: function () {
        return {
            cacheHelper: new CacheHelper(),
            line_image: "",
            dataDetail: {},
            dataSet: {},
            activeTab: "",
        };
    },
    mixins: [Mixin],
    async created() {
        this.handleLoading(true);
        await this.getProfile();
        this.line_image = this.cacheHelper.getCache("BzbsUser").line.pictureUrl;
        this.activeTab = this.tiermixin;
        Promise.all([this.getBlob()]).then(() => {
            if (Object.keys(this.dataDetail).length > 0) {
                this.dataSet = this.dataDetail[this.tiermixin];
            }
            this.handleLoading(false);
        });
    },
    watch: {
        activeTab(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.activeTab = newVal;
            }
        },
    },
    computed: mapGetters(["getUserlevel"]),
    methods: {
        getBlob() {
            const url =
                "/nestle/nescafe_streetcafe/MissionHome/config_benefit.json";
            return new Promise((resolve, reject) => {
                BzbsCustom.apiGetCustom(url)
                    .then((response) => {
                        this.dataDetail = response.dataDetail;
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        clickTab(name) {
            this.activeTab = name.toLowerCase();
            for (let i = 0; i <= Object.keys(this.dataDetail).length; i++) {
                if (Object.keys(this.dataDetail)[i] === name) {
                    this.dataSet =
                        this.dataDetail[Object.keys(this.dataDetail)[i]];
                }
            }
        },
        backHistory() {
            this.$router.go(-1);
        },
    },
};
</script>

<style lang="scss" scoped>
@import "@/module/Menu/style/mission.scss";

$primary-color: #a7907b;
.banner-main {
    margin: 0 20px;
    .banner-header {
        width: 100%;
        margin-bottom: -2px;
        img {
            width: 100%;
        }
    }
    .banner-body {
        padding: 10px 15px 20px;
        background-color: #fff;

        .banner-point {
            text-align: center;
            color: $color-text-light;
            font-size: 14px;
            margin-bottom: 10px;
            span {
                color: $primary-color;
                font-size: 16px;
                font-family: "PromptSemiBold";
                &.bronze {
                    color: #a7907b;
                }
                &.silver {
                    color: #51504f;
                }
                &.gold {
                    color: #a27939;
                }
            }
        }
        .progressbar-container {
            margin-bottom: 10px;
            .pointmark-container {
                display: flex;
                justify-content: space-between;
                font-size: 10px;
                font-family: "PromptSemiBold";
                .point {
                    color: $color-brown-600;
                }
                .bronze {
                    color: $primary-color;
                }
                .silver {
                    color: #51504f;
                }
                .gold {
                    color: #a27939;
                }
            }
            .progressbar {
                position: relative;
                width: 100%;
                margin-bottom: 10px;
                .line-image {
                    position: absolute;
                    top: -11px;
                    img {
                        border-radius: 15px;
                        height: 16px;
                        &.bronze {
                            border: solid 2px #a7907b;
                        }
                        &.silver {
                            border: solid 2px #51504f;
                        }
                        &.gold {
                            border: solid 2px #a27939;
                        }
                    }
                }
                .inactive {
                    height: 5px;
                    background-color: rgba(0, 0, 0, 0.2);
                    border-radius: 6px;
                }
                .active {
                    border-radius: 6px;
                    height: 5px;
                    position: absolute;
                    top: 0;
                    &.bronze {
                        background-image: linear-gradient(
                            to right,
                            #ebd1ba 0%,
                            $primary-color 100%
                        );
                    }
                    &.silver {
                        background-image: linear-gradient(
                            to right,
                            #aeaeae 0%,
                            #464544 100%
                        );
                    }
                    &.gold {
                        background-image: linear-gradient(
                            to right,
                            #d0b36d 0%,
                            #74582f 100%
                        );
                    }
                }
            }
        }
        .collect-point {
            font-family: "PromptSemiBold";
            color: $color-text;
            font-size: 14px;
            text-align: center;
        }
        .tier-desc,
        .tier-date {
            color: $color-brown-600;
            font-size: 14px;
            text-align: center;
        }
    }
}
.detail-main {
    padding: 20px;
    background-color: $color-light-grey-500;
    border-top-right-radius: 20px;
    border-top-left-radius: 20px;
    min-height: calc(100vh - 220px);
    .tab-main {
        display: flex;
        .tab-container {
            margin-right: 15px;
            border-radius: 20px;
            padding: 4px 12px;
            color: #fff;
            background-color: $color-text;
            &.active {
                background-color: #fff;
                color: $color-text;
            }
        }
    }
    .line {
        width: 100%;
        height: 2px;
        background-color: $color-light-grey-600;
        margin: 16px 0;
    }
    .congrat-container {
        font-size: 16px;
        margin-bottom: 12px;
        color: $color-text-light;
    }
    .level-container {
        color: $color-text;
        font-family: "PromptSemiBold";
        font-size: 18px;
        margin-bottom: 15px;
    }
    .benefit-container {
        display: flex;
        margin-bottom: 20px;
        img {
            height: 50px;
            margin-right: 15px;
        }
        .text-container {
            .header {
                color: $color-text;
                font-family: "PromptSemiBold";
                font-size: 16px;
            }
            .desc {
                color: $color-text-light;
                font-size: 16px;
            }
        }
    }
}
.wrapper-bg {
    padding: 0;
}
</style>
